const formatTlText = (node) => {
  if (node.nodeType === Node.TEXT_NODE) {
    if (!node.parentElement?.closest('script, style, textarea, input')) {
      const formatted = node.nodeValue.replace(/(\d)\s*TL\b/g, '$1 TL');
      if (formatted !== node.nodeValue) node.nodeValue = formatted;
    }
    return;
  }

  if (!(node instanceof Element) || node.matches('script, style, textarea, input')) return;

  const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
  let textNode;
  while ((textNode = walker.nextNode())) formatTlText(textNode);
};

formatTlText(document.body);

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'characterData') formatTlText(mutation.target);
    mutation.addedNodes.forEach(formatTlText);
  }
}).observe(document.body, { childList: true, characterData: true, subtree: true });
